'use strict';

var widgetGenerator = {
    MAX_DIMENSIONS: 460,
    init: function() {
        const { url: { widgetUrls: { script = 'https://www.discovercars.com/widget.js?v1' } = {} } } = _d;
        const WIDGET_FORM_ID = '#configuration-form';
        const AFFILIATE_CODE_ID = '#affiliate-code';
        const PICK_CITY_CODE_ID = '#pick_city_chosen';
        const COUNTRY_CODE_ID = '#countryUrl';
        const CITY_CODE_ID = '#cityUrl';
        const TEN_SECONDS_IN_MILLISECONDS = 10000;
        const HALF_SECOND_IN_MILLISECONDS = 500;
        const affiliateCodeDataAttr = 'data-utm-source';
        const bodyElement = $('body');
        const colorElementsListIds = ['form-bg-color', 'form-font-color', 'submit-bg-color', 'submit-font-color', 'title-color'];
        const dataAttributesList = [
            { name: 'id', value: 'dchwidget' },
            { name: 'src', value: script },
            { name: 'data-dev-env', value: 'com' },
            { name: 'data-location', value: '' },
            { name: 'data-lang', value: 'en' },
            { name: 'data-currency', value: '', iframe: 'currency'},
            { name: 'data-utm-source', value: '', iframe: 'utm_source'},
            { name: 'data-utm-medium', value: 'widget', iframe: 'utm_medium'},
            { name: 'data-aff-code', value: 'a_aid', iframe: 'aff_code'},
            { name: 'data-aff-channel', value: '', iframe: 'chan'},
            { name: 'data-aff-data1', value: '', iframe: 'data1'},
            { name: 'data-aff-data2', value: '', iframe: 'data2'},
            { name: 'data-autocomplete', value: 'on', iframe: 'autocomplete'},
            { name: 'data-style-submit-bg-color', value: '00A200', iframe: 'style_submit_bg_color'},
            { name: 'data-style-submit-font-color', value: 'white', iframe: 'style_submit_font_color'},
            { name: 'data-style-form-bg-color', value: 'FAD130', iframe: 'style_form_bg_color'},
            { name: 'data-style-form-font-color', value: '333', iframe: 'style_form_font_color'},
            { name: 'data-style-submit-text', value: 'Search now', iframe: 'submit_text'},
            { name: 'data-title-text', value: '', iframe: 'title_text'},
            { name: 'data-iframe-height', value: '', iframe: 'height'},
            { name: 'data-iframe-width', value: '', iframe: 'width'},
            { name: 'data-style-title-color', value: '00A200', iframe: 'style_title_color'},
            { name: '', value: '', iframe: 'responsive'},
            { name: 'async', value: '' }
        ];

        widgetGenerator.populateStorage('set', dataAttributesList);

        $('#responsive').on('change', function() {
            const isChecked = Boolean($(this).is(':checked'));
            const $widgetHeightInput = $('#widget-height');
            const $widgetWidthInput = $('#widget-width');
            const $previewLimit = $('#preview-limit');

            if (isChecked) {
                $widgetHeightInput.attr('disabled', true);
                $widgetHeightInput.parent().find('label').addClass('text-gray-500');

                $widgetWidthInput.attr('disabled', true);
                $widgetWidthInput.parent().find('label').addClass('text-gray-500');

                $previewLimit.addClass('text-gray-500');
            } else {
                $widgetHeightInput.removeAttr('disabled');
                $widgetHeightInput.parent().find('label').removeClass('text-gray-500');

                $widgetWidthInput.removeAttr('disabled');
                $widgetWidthInput.parent().find('label').removeClass('text-gray-500');

                $previewLimit.removeClass('text-gray-500');
            }
        });

        bodyElement.on('change', '#submit-bg-color, #form-bg-color, #form-font-color, #submit-font-color, #title-color', function(event) {
            event.preventDefault();
            const colorPickerValue = event.target.value;
            const textElement = $(`.${event.target.id}-value`);
            textElement.val(colorPickerValue);
        });

        bodyElement.on('change', '.submit-bg-color-value, .form-bg-color-value, .form-font-color-value, .submit-font-color-value, .title-color-value', function(event) {
            event.preventDefault();
            const inputColorValue = `${event.target.value}`;
            const inputFieldClassName = (event.target.className).replace('-value', '');
            const colorPickerElement = $(`#${inputFieldClassName}`);
            colorPickerElement.val(inputColorValue).trigger('change');
        });

        bodyElement.on('click', 'input.widget-reset', function() {
            location.reload();
        });

        bodyElement.on('click', 'button.widget-submit', function(event) {
            event.preventDefault();
            const formData = $(WIDGET_FORM_ID).serializeArray();
            const newFieldList = [];
            const pickCityField = $(PICK_CITY_CODE_ID);
            const cityCodeField = $(CITY_CODE_ID);
            let isRequiredFieldValid = true;
            let firstErrorElement = null;

            formData.forEach(({ name, value }) => {
                if (name === affiliateCodeDataAttr) {
                    const isValid = Boolean(value);
                    $(AFFILIATE_CODE_ID).toggleClass('required-error', !isValid);
                    $('span.affiliate-req-error').toggleClass('show', !isValid);

                    if (!isValid && !firstErrorElement) {
                        firstErrorElement = $(AFFILIATE_CODE_ID);
                    }

                    isRequiredFieldValid = isValid && isRequiredFieldValid;
                }

                newFieldList.push({ 'name': name, 'value': value });
            });

            setTimeout(() => {
                const cityCodeValue = cityCodeField.val();
                const countryCodeValue = $(COUNTRY_CODE_ID).val();

                if (countryCodeValue) {
                    const isValid = Boolean(cityCodeValue);
                    pickCityField.toggleClass('required-error', !isValid);
                    $('span.city-req-error').toggleClass('show', !isValid);

                    if (!isValid && !firstErrorElement) {
                        firstErrorElement = pickCityField;
                    }

                    isRequiredFieldValid = isValid && isRequiredFieldValid;
                }

                if (!isRequiredFieldValid && firstErrorElement) {
                    $('html').animate({scrollTop: 0}, 'slow');
                }
            }, HALF_SECOND_IN_MILLISECONDS);

            if (isRequiredFieldValid) {
                widgetGenerator.copyToEmbedArea(newFieldList);
            }
        });

        bodyElement.on('click', '#embed-code-copy', function(event) {
            widgetGenerator.setCopyEvent(event, $('.embed-code-area'), $(AFFILIATE_CODE_ID), TEN_SECONDS_IN_MILLISECONDS);
        });

        bodyElement.on('click', '#aff-link-copy', function(event) {
            widgetGenerator.setCopyEvent(event, $('.aff-link-area'), $(AFFILIATE_CODE_ID), TEN_SECONDS_IN_MILLISECONDS);
        });

        widgetGenerator.updateWidgetColors(colorElementsListIds);
        widgetGenerator.setCurrencyForPreview(bodyElement);
    },
    setCopyEvent: function(event, areaElement, affCodeElement, timeoutValue) {
        event.preventDefault();

        if (affCodeElement.val()) {
            widgetGenerator.copyToClipboard(areaElement);
            event.target.innerHTML = $('.clipboardCopied').text();

            setTimeout(() => {
                event.target.innerHTML = $('.copyCode').text();
            }, timeoutValue);
        }
    },
    getAffLinkFullPath: function(allFields) {
        const normalizedFields = [];
        allFields.forEach(item => normalizedFields[item.name] = (item.value !== undefined && item.value.length) ? item.value : undefined);

        const params = {
            'a_aid': normalizedFields['data-utm-source'],
            'chan': normalizedFields['data-aff-channel'],
            'data1': normalizedFields['data-aff-data1'],
            'data2': normalizedFields['data-aff-data2']
        };

        if (normalizedFields['data-currency'] !== undefined) { params['currency'] = normalizedFields['data-currency']; }

        const path = [normalizedFields.countryUrl, normalizedFields.cityUrl, normalizedFields.locationUrl]
            .filter(location => location !== undefined && location !== 'undefined' && location.length)
            .map(location => location.toLowerCase())
            .join('/');

        const lang = (normalizedFields['data-lang'] !== undefined && normalizedFields['data-lang'] !== 'en') ? '/' + normalizedFields['data-lang'] : '';

        const getParams = Object.entries(params)
            .filter(param => param[1] !== undefined && param[1] !== 'undefined' && param[1].length)
            .map(pair => pair.join('='))
            .join('&');

        return _d.url.host + lang + (path.length ? '/' + path : '') + (getParams.length ? '?' + getParams : '');
    },
    copyToEmbedArea: function(newFieldList) {
        const scriptTag = widgetGenerator.updatePreviewSection(newFieldList);
        const url = widgetGenerator.getAffLinkFullPath(newFieldList);
        const embedArea = $('.embed-code-area');
        const affUrlArea = $('.aff-link-area');

        embedArea.text(scriptTag);
        affUrlArea.text(url);
    },
    copyToClipboard: function(el) {
        const scriptTag = el.text();
        const tempInput = $('<input>');
        $('body').append(tempInput);
        tempInput.val(scriptTag).select();
        document.execCommand('copy');
        tempInput.remove();
    },
    locationFieldsCombine: function() {
        const locationFieldsList = ['#countryUrl', '#cityUrl', '#locationUrl'];
        const locationsValues = [];

        locationFieldsList.forEach(fieldName => {
            const fieldValue = $(fieldName).val();
            if ($(fieldName).val()!=='undefined' && $(fieldName).val()!=='') {
                locationsValues.push(fieldValue);
            }
        });

        return locationsValues.join('/');
    },
    updatePreviewSection: function(newFieldList = []) {
        const script = $('<script />');
        const combineString = [];
        const iFrameElement = $('#discoFrameId');
        const dataAttributeListFromStorage = widgetGenerator.populateStorage('get');
        const clonedFieldList = JSON.parse(JSON.stringify(dataAttributeListFromStorage));

        // Replace default fields value with new value
        newFieldList.forEach( ({ name, value }) => {
            const itemIndex = clonedFieldList.findIndex((item) => item.name === name);

            if (clonedFieldList[itemIndex]) {
                clonedFieldList[itemIndex].value = value;
            }
        });

        const instanceType = clonedFieldList.find(field => field.name === 'data-dev-env');
        const fullPath = widgetGenerator.getWidgetFullPath(instanceType.value);

        clonedFieldList.forEach(({name, value, iframe}) => {
            if (!value) {
                return;
            }

            if (iframe) {
                if (value.substring(0, 1) === '#') {
                    combineString.push(`${iframe}=${encodeURIComponent(value)}`);
                } else {
                    combineString.push(`${iframe}=${value}`);
                }
            }

            if (iframe === 'autocomplete') {
                iFrameElement.toggleClass('offComplete', value === 'off');
            }

            if (iframe === 'title_text') {
                iFrameElement.toggleClass('onTitle', value !== '');
            }

            if (!name) {
                return;
            }

            script.attr(name, value);
        });

        if ($('#responsive').is(':checked')) {
            combineString.push('responsive=on');
        }

        const isAutocompleteAndTitle = script.attr('data-autocomplete') === 'off' && script.attr('data-title-text') !== '';
        iFrameElement.toggleClass('offCompOnTitle', isAutocompleteAndTitle);

        script.attr('data-location', widgetGenerator.locationFieldsCombine());
        iFrameElement.attr('src', `${fullPath}${combineString.join('&')}`);

        widgetGenerator.setIframeDimensions(iFrameElement, clonedFieldList);

        return `<div>${script[0].outerHTML}</div>`;
    },
    getWidgetFullPath: function(instanceType) {
        const { url: { widgetUrls: { dev, prod } } } = _d;
        const widgetUrl = instanceType === 'com' ? `https://${prod}` : `https://${dev}`;
        const lang = $('#language').val();
        const location = `locations/${widgetGenerator.locationFieldsCombine()}?`;
        return lang ? `${widgetUrl}/${lang}/${location}` : `${widgetUrl}/${location}`;
    },
    populateStorage: function(type, data) {
        if (type === 'get') {
            const dataAttributeListFromStorage = localStorage.getItem('dataAttributesList');

            return JSON.parse(dataAttributeListFromStorage);
        }

        localStorage.setItem('dataAttributesList', JSON.stringify(data));
    },
    setIframeDimensions: function(iFrameElement, clonedFieldList) {
        const iFrameWidth = clonedFieldList.find(field => field.name === 'data-iframe-width');
        const iFrameHeight = clonedFieldList.find(field => field.name === 'data-iframe-height');

        if ($('#responsive').is(':checked')) {
            iFrameElement.attr('width', '100%');
            return;
        }

        iFrameElement.attr('width', `${iFrameWidth.value}px`);
        iFrameElement.attr('height', `${iFrameHeight.value}px`);
    },
    updateWidgetColors(colorElementsListIds) {
        colorElementsListIds.forEach(colorElementId => {
            const colorElement = $(`#${ colorElementId }`);

            colorElement.change(() => {
                const dataAttributeListFromStorage = widgetGenerator.populateStorage('get');
                const changedColorFieldIndex = dataAttributeListFromStorage.findIndex(attribute => attribute.name === `data-style-${ colorElementId }`);
                dataAttributeListFromStorage[changedColorFieldIndex].value = colorElement.val();

                widgetGenerator.populateStorage('set', dataAttributeListFromStorage);
                widgetGenerator.updatePreviewSection();
            });
        });
    },
    setCurrencyForPreview(bodyElement) {
        bodyElement.on('change', '#currency', function(event) {
            event.preventDefault();

            const currencyCode = event.target.value;
            const dataAttributeListFromStorage = widgetGenerator.populateStorage('get');
            const changedColorFieldIndex = dataAttributeListFromStorage.findIndex(attribute => attribute.name === 'data-currency');
            dataAttributeListFromStorage[changedColorFieldIndex].value = currencyCode;

            widgetGenerator.populateStorage('set', dataAttributeListFromStorage);
            widgetGenerator.updatePreviewSection();
        });
    }
};
